import { cn } from "@theprelude/core";
import { useId } from "react";

export const LoaderIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => {
  const clipPathId = useId();
  const gradientId = useId();

  return (
    <svg
      className={cn("size-4 flex-shrink-0", className)}
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8"
          stroke={`url(#${gradientId})`}
          strokeWidth="2"
        />
        <path
          d="M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8"
          stroke="#3D4246"
          strokeWidth="2"
        />
      </g>
      <defs>
        <linearGradient
          id={gradientId}
          x1="1"
          y1="8"
          x2="15"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#3D4246" />
        </linearGradient>
        <clipPath id={clipPathId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
